module.exports = __webpack_public_path__ + "static/media/cube-sat.85852927.jpeg";